/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamReferenceShow200,
  GetApiV1ExamReferenceShow401,
  GetApiV1ExamReferenceShow500,
  GetApiV1ExamReferenceShowQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamReferenceShow.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamReferenceShow200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamReferenceShow200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamReferenceShow401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamReferenceShow401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamReferenceShow500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamReferenceShow500>;

export const getApiV1ExamReferenceShowQueryResponseSchema = z.lazy(
  () => getApiV1ExamReferenceShow200Schema,
) as unknown as ToZod<GetApiV1ExamReferenceShowQueryResponse>;
